/* eslint-disable */
const state = {
  selectOrderDetail: [], // 选中的订单信息
  // 商品详情页数据（用于跳转到订单页）
  goodDetailOrderData: null,
  // 商品详情页状态（用于返回时恢复）
  timeLimitDetailState: null
}

// getters
const getters = {
  selectOrderDetailGetter: (state) => state.selectOrderDetail,
  goodDetailOrderDataGetter: (state) => state.goodDetailOrderData,
  timeLimitDetailStateGetter: (state) => state.timeLimitDetailState
}

// actions
const actions = {

}

// mutations
const mutations = {
  setSelectOrderDetail(state, value) { state.selectOrderDetail = value },
  // 设置商品详情订单数据
  setGoodDetailOrderData(state, value) { state.goodDetailOrderData = value },
  // 设置商品详情页状态
  setTimeLimitDetailState(state, value) { state.timeLimitDetailState = value },
  // 清除商品详情订单数据
  clearGoodDetailOrderData(state) { state.goodDetailOrderData = null }
}

export default {
  state,
  getters,
  actions,
  mutations
}
